
import { Component, Prop, Vue } from 'vue-property-decorator'
import LsDialog from '@/components/ls-dialog.vue'
import LsPagination from '@/components/ls-pagination.vue'
import { apiDelivery } from '@/api/order'

@Component({
  components: {
    LsDialog,
    LsPagination,
  }
})
export default class OrderPane extends Vue {
  $refs!: { paneTable: any; verifyDialogRef: any }
  @Prop() value: any
  @Prop() pager!: any

  selectIds: any = []

  remarks = '' //商家备注

  verifyTips = ''

  // 发货弹窗控制
  deliverDialogVisible = false

  // 当前发货订单
  currentOrder: any = {}

  // 发货表单
  deliverForm: any = {
    orderSn: '', // 订单号
    expressNo: '' // 快递单号
  }
  form: any = {
    order_sn: '', //否	string	订单信息
    order_status : 1
  }
  // 获取订单信息
  getOrderLists() {
    ;(this.$parent as any).apiOrderListsNews({ page: this.pager.currentPage, ...this.form})
  }

  // 选择某条数据
  selectionChange(val: any[]) {
    this.selectIds = val.map(item => item.id)
  }

  // 全选
  selectAll() {
    ;(this.$refs.paneTable as any).toggleAllSelection()
  }

  // 去订单详情
  toOrder(id: any) {
    this.$router.push({
      path: '/order/order_detail',
      query: { id }
    })
  }

  toUser(id: any) {
    this.$router.push({
      path: '/user/user_details',
      query: { id: id }
    })
  }

  // 处理发货
  handleDeliver(order: any) {
    this.currentOrder = order
    this.deliverForm.orderSn = order.sn
    this.deliverForm.expressNo = ''
    this.deliverDialogVisible = true
  }

  // 格式化URL用于跳转（添加https）
  formatUrl(url: string): string {
    if (!url) return ''
    // 如果已经有协议前缀，直接返回
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url
    }
    // 否则添加https前缀
    return 'https://' + url
  }

  // 格式化URL用于显示（添加https）
  formatUrlDisplay(url: string): string {
    if (!url) return ''
    // 如果已经有协议前缀，直接返回
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url
    }
    // 否则添加https前缀用于显示
    return 'https://' + url
  }

  // 提交发货
  async submitDelivery() {
    if (!this.deliverForm.expressNo) {
      this.$message.error('请输入快递单号')
      return
    }

    try {
      const params = {
        id: this.currentOrder.id,
        delivery_type: 1, // 默认快递发货
        express_company: '', // 快递公司可以为空
        express_no: this.deliverForm.expressNo,
        delivery_remark: '' // 发货说明可以为空
      }

      await apiDelivery(params)
      this.$message.success('发货成功')
      this.deliverDialogVisible = false
      this.getOrderLists() // 刷新列表
      this.$emit('refresh')
    } catch (error) {
      this.$message.error('发货失败')
    }
  }
}
